module.exports = __webpack_public_path__ + "static/Webconference-e0f78ad8e2249e73f6904fe2209f0fb2.png";